import { useState } from "react";
import "./App.css";

import Navbar from "./Components/Navbar";
import TextForm from "./Components/TextForm";
import Newabout from "./Newabout";
import Alert from "./Components/Alert";
import React from "react";
import { BrowserRouter as Router, Routes, Route} from "react-router-dom";

function App() {
  const [mode, setMode] = useState("light"); // Whether dark mode is enabled or not
  const [alert, setAlert] = useState(null);

  const showAlert = (message, type) => {
    setAlert({
      msg: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 2000);
  };
const removeBodyClasses=()=>{
  document.body.classList.remove('bg-light');
  document.body.classList.remove('bg-dark');
  document.body.classList.remove('bg-secondary');
  document.body.classList.remove('bg-info');
  document.body.classList.remove('bg-primary');
}

  const toggleMode = (cls) => {
    removeBodyClasses();
    if (mode === "dark") {
      setMode("light");
      document.body.style.backgroundColor = "white";
      showAlert("   Light mode has been enabled", "success");
    } else {
      setMode("dark");
      document.body.style.backgroundColor = "#042743";
      showAlert("   Dark mode has been enabled", "success");
    }
    document.body.classList.add('bg-'+cls);
  };
  return (
    <>
      <Router>
        <Navbar title="TextMate" mode={mode} toggleMode={toggleMode} />
        <Alert alert={alert}></Alert>
        {/* <Newabout mode={mode} /> */}
        <div className="container my-3">
          <Routes>
            <Route path="/Newabout" element={<Newabout mode={mode}/>}  />

            <Route
              path="/"
              element={
                <TextForm
                  showAlert={showAlert}
                  heading="Enter The Text"
                  mode={mode}
                />
              }
            />
          </Routes>
        </div>
      </Router>
    </>
  );
}

export default App;
